import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VisibilityService {

  constructor(private http: HttpClient) { }

  getVisibility(body?): Observable<any> {
    body = body || {} 
    return this.http.post(`${environment.apiUrl}/trackvision/visibility`, body, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
    });
  }

  getVisibilityById(visibilityId): Observable<any> {
    return this.http.get(`${environment.apiUrl}/trackvision/visibility/get/${visibilityId}`, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
    });
  }

  saveVisibility(visibility): Observable<any> {
    return this.http.post(`${environment.apiUrl}/trackvision/visibility/update`, visibility, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
    })
  }
}
